export const actionTypes = {
  TOGGLE_OVERVIEW_SIDEBAR: 'TOGGLE_OVERVIEW_SIDEBAR',
  SHOW_CONFIGURATION_OVERVIEW: 'SHOW_CONFIGURATION_OVERVIEW',
  SHOW_PRODUCT_PARTS: 'SHOW_PRODUCT_PARTS',
};

export const toggleOverviewSidebar = () => ({
  type: actionTypes.TOGGLE_OVERVIEW_SIDEBAR,
});

export const showConfigurationOverView = () => ({
  type: actionTypes.SHOW_CONFIGURATION_OVERVIEW,
});

export const showProductParts = () => ({
  type: actionTypes.SHOW_PRODUCT_PARTS,
});
